import React, { useState, useEffect } from 'react';
import { Row, Col, Badge, Button } from 'reactstrap';
import CoverUploader from './ImageUpload/CoverUploader';
import LogoUploader from './ImageUpload/LogoUploader';

interface EditShopMediaProps {
  id: string;
  name: string;
  isActive: boolean;
  logoUrl: string;
  coverImageUrl: string;
}

const EditShopMedia: React.FC<EditShopMediaProps> = ({
  id,
  name,
  isActive,
  logoUrl: initialLogoUrl,
  coverImageUrl: initialCoverImageUrl,
}) => {
  const [logoUrl, setLogoUrl] = useState<string>(initialLogoUrl);
  const [coverImageUrl, setCoverImageUrl] = useState<string>(initialCoverImageUrl);
  const [localIsActive, setLocalIsActive] = useState<boolean>(isActive);

  useEffect(() => {
    setLogoUrl(initialLogoUrl);
  }, [initialLogoUrl]);

  useEffect(() => {
    setCoverImageUrl(initialCoverImageUrl);
  }, [initialCoverImageUrl]);

  const handleToggleActive = () => {
    const newIsActive = !localIsActive;
    setLocalIsActive(newIsActive);
  };

  return (
    <div>
      <CoverUploader
        shopId={id}
        coverImageUrl={coverImageUrl}
        onUploaded={(url) => setCoverImageUrl(url)}
      />

      {/* Logo and Info */}
      <Row className="align-items-center mb-4">
        <Col md="8" sm="12" className="d-flex align-items-center">
          <div className="me-3" style={{ flexShrink: 0 }}>
            <LogoUploader
              shopId={id}
              logoUrl={logoUrl}
              onUploaded={(url) => setLogoUrl(url)}
            />
          </div>
          <div>
            <h2 className="mb-1">{name}</h2>
            <Badge color={localIsActive ? 'success' : 'secondary'} pill>
              {localIsActive ? 'Active' : 'Inactive'}
            </Badge>
          </div>
        </Col>
        <Col md="4" sm="12" className="text-md-end mt-3 mt-md-0">
          <Button
            color={localIsActive ? 'danger' : 'success'}
            className="me-2"
            onClick={handleToggleActive}
          >
            {localIsActive ? 'Deactivate' : 'Activate'}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default EditShopMedia;
